export default __webpack_public_path__ + "static/media/PA.177c188d.svg";